import { SW_MESSAGE_TYPES } from '@/service-worker/shared/Constants'

const preloadEndpoints: { path: string; cache: boolean }[] = [
    { path: `/all`, cache: true },
    { path: `/Api/UserSettings`, cache: true },
    { path: `/plants?onboardedOnly=true`, cache: true },
]

// Must stay in sync with getOnboardedSensors, otherwise we warm a URL the app never requests.
const sensorListPath = (plant: string): string =>
    plant ? `/Api/InstalledSensors/plant/${encodeURIComponent(plant)}/sensors` : `/Api/InstalledSensors/All`

// These endpoints require a plant, so there is nothing to warm while "All plants" is selected.
const plantEndpoints = (plant: string): { path: string; cache: boolean }[] => {
    if (!plant) return []

    const encodedPlant = encodeURIComponent(plant)
    return [
        { path: `/plants/projects/plant/${encodedPlant}`, cache: true },
        { path: `/plants/systems/plant/${encodedPlant}`, cache: true },
        { path: `/plants/areas/plant/${encodedPlant}`, cache: true },
    ]
}

export const preloadApiCache = async (token: string, base: string, plant = '') => {
    const endpoints = [{ path: sensorListPath(plant), cache: true }, ...preloadEndpoints, ...plantEndpoints(plant)]

    await Promise.all(
        endpoints.map(async ({ path, cache }) => {
            try {
                const res = await fetch(`${base}${path}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    cache: cache ? 'no-store' : 'no-cache',
                })

                if (!res.ok) throw new Error(`[Preload] ${path} failed with status ${res.status}`)
            } catch (err) {
                console.warn(`[ApiPreloader] Failed to preload ${path}`, err)
            }
        })
    )

    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
            type: SW_MESSAGE_TYPES.PRELOAD_COMPLETE,
        })
    }
}
